
<div class="cp-select" ref="drop" :class="{ isopen: isDrop }">
  <div
    :class="['selection-show', isDrop ? 'isopen' : '']"
    @click="toggleDrop"
  >
    <span>{{
      key
        ? `${options[nowIndex].zone_name || options[nowIndex].char_name}`
        : placeholder
    }}</span>
    <div :class="['arrow', isDrop ? 'isopen' : '']"></div>
    <div class="divider" v-show="isDrop && nowIndex > 0"></div>
  </div>
  <div class="selection-list" v-show="isDrop">
    <ul v-if="options">
      <li
        :class="['selection-item', index == nowIndex ? 'selected' : '']"
        v-for="(item, index) in options"
        :key="index"
        @click="chooseSelection(index, item)"
      >
        {{ item.zone_name || item.char_name }}
      </li>
    </ul>
  </div>
</div>
